import { ROUTE_PATH, TEMPLATE_OPTIONS } from 'common/constants/sm-constants';
import {
  FormMetaModel,
  SmMetaSelectModel,
  SmBtnMetaModel,
  SmCheckboxModel,
} from 'common/models/utility-models/meta-model';

export class MentorMappingMetaModel extends FormMetaModel {
  constructor() {
    super('Map Mentor', ROUTE_PATH.mentorMappingList, '', 3);
  }

  override initProperties(): any {
    const formInfo = super.initProperties();

    const mentorId = new SmMetaSelectModel(
      'mentorId',
      'mentorId',
      'select',
      true,
      'col-12 col-md-6 col-lg-6',
      1,
      1,
      'Select Mentor',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'mentorName',
      'id'
    );
    const batch_id = new SmMetaSelectModel(
      'batch_id',
      'batch_id',
      'select',
      false,
      'col-12 col-md-6 col-lg-6',
      1,
      2,
      'Select Batch',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'batch_number',
      'id'
    );
    const branch_id = new SmMetaSelectModel(
      'branch_id',
      'branch_id',
      'select',
      false,
      'col-12 col-md-6 col-lg-6',
      1,
      2,
      'Select Branch',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'department_name',
      'id'
    );
    const group_id = new SmMetaSelectModel(
      'group_id',
      'group_id',
      'select',
      false,
      'col-12 col-md-6 col-lg-6',
      1,
      2,
      'Select Group',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'group_name',
      'id'
    );
    const east = new SmCheckboxModel(
      'east',
      'east',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'East',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );
    const west = new SmCheckboxModel(
      'west',
      'west',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'West',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );
    const north = new SmCheckboxModel(
      'north',
      'north',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'North',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );
    const south = new SmCheckboxModel(
      'south',
      'south',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'South',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );

    const student_ids = new SmMetaSelectModel(
      'student_ids',
      'student_ids',
      'ng-select',
      true,
      'col-12 col-md-6 col-lg-6',
      1,
      2,
      'Select Students',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      [],
      'name',
      'id',
      true
    );

    const buttons = {
      submit: new SmBtnMetaModel('SUBMIT', '', true, false, true, true),
      isFormControl: false,
    };
    return {
      formInfo,
      buttons,
      mentorId,
      batch_id,
      student_ids,
      branch_id,
      // east, west, north, south,
      group_id,
    };
  }
}
